export default __webpack_public_path__ + "static/media/STORIES.cc36ebca.png";